import React, { useMemo } from 'react';
import { StyleSheet, View } from '@react-pdf/renderer';
import { TextBoldWarranty, TextRegularWarranty } from './TextWarranty';
import { ViewWarrantyRow } from './ViewWarranty';
import { Customer } from 'src/types';
import { colors } from 'src/constants';
import { dateToday } from 'src/utils';

interface Props {
  customerInfo?: Customer;
  overrideOnURL?: string;
}

const styles = StyleSheet.create({
  root: {
    minHeight: 30,
    marginTop: 4
  },
  note: {
    flex: 2,
    padding: 4
  },
  noteTxt: {
    textAlign: 'justify',
    fontSize: 5,
    color: colors.grey[800]
  },
  noteTxtV2: {
    textAlign: 'justify',
    fontSize: 5
    // color: colors.grey[800]
  },
  customerContainer: {
    flex: 1,
    padding: 4,
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  customerNameTxt: {
    fontSize: 6,
    color: colors.grey[800]
  },
  underline: {
    width: 100,
    height: 0.5,
    backgroundColor: colors.grey[900]
  }
});

export const RenderFooter = ({ customerInfo, overrideOnURL = '' }: Props) => {
  const customerName = useMemo(() => {
    const firstName = customerInfo?.first_name ?? '';
    const lastName = customerInfo?.last_name ?? '';
    return `${firstName} ${lastName}`;
  }, [customerInfo]);

  const printTime = useMemo(() => {
    const date = dateToday('PP');
    return date
  }, []);

  return (
    <ViewWarrantyRow style={styles.root}>
      <View style={styles.note}>
        {overrideOnURL ? (
          <TextRegularWarranty style={styles.noteTxt}>
            {`I, CUSTOMER OF PC WORTH, RECEIVED THE ABOVE ITEM(S) IN GOOD CONDITION. ALSO, I AGREE TO THE WARRANTY TERMS & CONDITIONS WRITTEN ON THE BACK OF THIS WARRANTY SLIP`}
          </TextRegularWarranty>
        ) : (
          <div>
            <TextRegularWarranty style={styles.noteTxtV2}>
              Disclaimer: This document is issued for warranty reference
              purposes only and is not valid nor a substitute for a Sales
              Invoice. Any similarity in format and details herein are for
              internal and customer documentation related to product warranty
              and replacement eligibility only.
            </TextRegularWarranty>

            <TextRegularWarranty style={styles.noteTxtV2}>
              {printTime}
            </TextRegularWarranty>
          </div>
        )}
      </View>

      {overrideOnURL ? (
        <View style={styles.customerContainer}>
          <TextRegularWarranty style={styles.customerNameTxt}>
            {customerName}
          </TextRegularWarranty>
          <View style={styles.underline} />
          <TextBoldWarranty>Customer Signature</TextBoldWarranty>
        </View>
      ) : null}
    </ViewWarrantyRow>
  );
};
